module.exports = __webpack_public_path__ + "img/img09.75bb1cad.svg";